export var FUNCTIONAL_AREA_STANDARD = 'standard';
export var FUNCTIONAL_AREA_DOWNLOAD_BETRIEB = 'downloadbetrieb';
export var FUNCTIONAL_AREA_REBFLAECHEN = 'rebflaechen';
export var FUNCTIONAL_AREA_WEINERZEUGUNG = 'weinerzeugung';
export var FUNCTIONAL_AREA_HEKTARERTRAGSREGELUNG = 'hektarertragsregelung';
export var FUNCTIONAL_AREA_QUALITAET = 'qualitaet';
export var FUNCTIONAL_AREA_LANDESPRAEMIERUNG_WEIN_SEKT = 'landespraemierungweinsekt';
export var FUNCTIONAL_AREA_STAMMDATEN_BETRIEB = 'stammdatenbetrieb';
export var FUNCTIONAL_AREA_DOWNLOAD_BENUTZER = 'downloadbenutzer';
export var FUNCTIONAL_AREA_NUTZUNGSPROTOKOLL = 'nutzungsprotokoll';
export var FUNCTIONAL_AREA_BENUTZERDATEN = 'benutzerdaten';
export var FUNCTIONAL_AREA_NUTZERVERWALTUNG = 'nutzerverwaltung';
export var FUNCTIONAL_AREA_NUTZUNGSARTEN = 'nutzungsarten';
